import _ from 'lodash';
import {Button as AntButton, Modal, Select, Table, TableColumnsType} from 'antd';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import { useEffect, useState } from 'react';
import Button from '../../../Button';
import { IEmployeeItem, IGetEmployees } from '../../../../models/financials.model';
import useAxios from '../../../../hooks/useAxios';
import { getEmployees } from '../../../../api/financials.api';
import { campusHeadOffice } from '../../../../lib/data';
import config from '../../../../lib/config';
import Pagination from '../../../Pagination';
import { ICampusItem } from '../../../../models/campuses.model';
import { IEmployeeValue } from '../../../../models/financials.model';
import useNotification from '../../../../hooks/useNotification';
import { ISubcode } from '../../../../models/codes.model';
import { ApprovalLineType } from '../../../../constans';

interface IProps {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    selectedMemberList: Map<string, IEmployeeValue>;
    setSelectedMemberList: (selectedMemberList: Map<string, IEmployeeValue>) => void;
    defaultLine: ISubcode[] | undefined;
    alType: ApprovalLineType;
    pCampusCode: string;
    setIsEdit?: (visible: boolean) => void;
}

const ApprovalLineModal = ({visible, setVisible, selectedMemberList, setSelectedMemberList, defaultLine, alType, setIsEdit, pCampusCode}: IProps) => {
    
    const { t, i18n } = useTranslation();
    const { infoNotification } = useNotification();
    const { auth } = useSelector((state: RootState) => state.auth);
    const { campusData } = useSelector((state: RootState) => state.campusData);    

    const {data: employeeRes, isLoading, error, execute,} = useAxios<IGetEmployees>();
    
    const [searchName, setSearchName] = useState<string | undefined>();
    const [campusCode, setCampusCode] = useState('');
    const [employeesData, setEmployeesData] = useState<IEmployeeItem[]>([]);
    const [page, setPage] = useState(1);
    const [lineMemberList, setLineMemberList] = useState<Map<string, IEmployeeValue>>();
    const [campusCodeList, setCampusCodeList] = useState<ICampusItem[]>();    

    useEffect(() => {
        initSearch();
        
        const tempCampusData = campusData.filter((item) => {
            return (item.campusCode === campusHeadOffice || item.campusCode === pCampusCode)
        })
        setCampusCode(auth.hqYn === 'Y' ? campusHeadOffice : pCampusCode);
        setCampusCodeList(tempCampusData);
        
        setLineMemberList(selectedMemberList);
    }, []);

    useEffect(() => {
        if (employeeRes && !isLoading) {
            let tempEmployeeList : IEmployeeItem[]  = _.cloneDeep(employeeRes.data);

            if (tempEmployeeList.length > 0) {
                let tempNo = 1;
                tempEmployeeList.forEach((item: any) => {
                    item.no = tempNo;
                    tempNo++;
                });
            }

            setEmployeesData(tempEmployeeList);
            onSearch();
        }
    }, [employeeRes, isLoading]);
    
    const initSearch = () => {
        let param = {
            campusCodes : [campusHeadOffice, pCampusCode]
        }

        execute(getEmployees(param));
    }

    const onSearch = () => {
        if (!employeeRes) return;

        let tempEmployeeList : IEmployeeItem[] = _.cloneDeep(employeeRes.data);      
        if(searchName) {
            tempEmployeeList = tempEmployeeList.filter((item: IEmployeeItem) =>
                                    (!campusCode || item.campusCode === campusCode) &&
                                    ((item.memberName + item.memberEngName).toLowerCase().includes(searchName.toLowerCase())));
        } else {
            tempEmployeeList = tempEmployeeList.filter((item: IEmployeeItem) => (!campusCode || item.campusCode === campusCode));
        }
        let tempNo = 1;
        tempEmployeeList.forEach((item: any) => {
            item.no = tempNo;
            tempNo++;
        });
        setPage(1);
        setEmployeesData(tempEmployeeList);
    }

    const onSave = () => {
        if(lineMemberList) {
            let tempSelData = new Map<string, IEmployeeValue>(lineMemberList?.entries()); 
            if(defaultLine && defaultLine.length > 0 && alType === ApprovalLineType.APPROVAL_LINE) {
                defaultLine.forEach((item:ISubcode)=>{
                    let finalData = tempSelData.get(item.detailCode);
                    if(finalData) {
                        tempSelData.delete(item.detailCode);
                        tempSelData.set(item.detailCode, finalData);
                    }
                });
            }
            setSelectedMemberList(tempSelData);
            if(setIsEdit) {
                setIsEdit(true);
            }
        }
        setVisible(false);
    }

    const fnSetSelectedMember = ({target} : any, record : IEmployeeItem) => {
        let isFinalLine = false;
        if(defaultLine && defaultLine.length > 0) {
            defaultLine.forEach((item:ISubcode)=>{
                if(item.detailCode === record.memberCode) {
                    isFinalLine = true;     
                }
            });
        }

        if(isFinalLine) {
            infoNotification(t('payment.expense.msg6'));
            return false;
        }

        let tempData = new Map<string, IEmployeeValue>(lineMemberList?.entries());
        if(target.checked) {
            const campusName = i18n.language === 'ko' ? record.campusName : record.campusEngName;
            const groupName = i18n.language === 'ko' ? record.groupName : record.groupEngName;
            const memberName = record.memberName + '(' + record.memberEngName + ')';
            tempData.set(record.memberCode, {campusCode: record.campusCode, campusName: campusName, groupName: groupName, memberName: memberName});
        } else {
            tempData.delete(record.memberCode);
        }
        setLineMemberList(tempData);
    }

    const columns: TableColumnsType<IEmployeeItem> = [
        {
            title: '#',
            dataIndex: 'no',
            key: 'no',
            align: 'center',
            width: '40px',
        },
        {
            title: t('campus.staff.placeholder2'),
            dataIndex: 'select',
            key: 'select',
            align: 'center',
            width: '50px',
            render: (value, record) => {
                return (<input type='checkbox' 
                               onChange={(e)=>fnSetSelectedMember(e, record)} 
                               checked={lineMemberList?.has(record.memberCode)}  
                               name='select' 
                        />);
            } 
        },
        {
          title: t('campus.staff.column38'),
          dataIndex: 'campusName',
          key: 'campusName',
          align: 'center',
          width: '150px',
          render: (value, record) => (i18n.language === 'ko' ? value : record.campusEngName)
        },
        {
          title: t('payment.expense.column9'),
          dataIndex: 'groupName',
          key: 'groupName',
          align: 'center',
          width: '150px',
          render: (value, record) => (i18n.language === 'ko' ? value : record.groupEngName)
        },
        {
          title: t('campus.staff.column35'),
          key: 'memberName',
          dataIndex: 'memberName',
          align: 'center',
          render: (value, record) => (<div className='text-left ant-table-cell-ellipsis'>{value + '(' + record.memberEngName + ')'}</div>)
        }
    ];    

    return (
        <Modal
            title={t('payment.expense.title1') + ' ' + t('campus.shuttle.button2')}
            width={750}
            open={visible}
            onCancel={() => setVisible(false)}
            footer={[
            <div className='comm-btn__area justify-content-center'>
                <AntButton
                    className='btn-basic pink'
                    onClick={onSave}
                >
                {t('common.button.save')}
                </AntButton>
                <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
                {t('common.button.close')}
                </AntButton>
            </div>
            ]}
        >
            <div>
                <div className="comm-bx__space">
                    <div className="comm-btn__area right">
                        <div className="w-150p">
                            <Select
                            className="w-100"
                            placeholder={t('common.button.select')}
                            value={campusCode}
                            onChange={(value) => setCampusCode(value)}
                            >
                                <Select.Option value="">
                                    {t('common.text.all')}
                                </Select.Option>
                                {
                                    campusCodeList?.map((item) => {
                                        return(
                                            <Select.Option
                                                key={item.campusCode}
                                                value={item.campusCode}
                                            >
                                            {i18n.language === 'ko' ? item.campusKorName : item.campusEngName}
                                            </Select.Option>
                                        );
                                    })
                                }
                            </Select>
                        </div>
                        <input
                            type="text"
                            className="form-control w-240p"
                            placeholder={t('common.text.input')}
                            value={searchName}
                            onChange={(e) => setSearchName(e.target.value)}
                            onKeyPress={(e) => {
                            if (e.key === 'Enter') onSearch();
                            }}
                        />
                        <div className='comm-btn__area justify-content-center'>
                            <Button
                                className="btn-basic small black"
                                onClick={onSearch}
                                text={t('common.button.search')}
                            />
                        </div>
                    </div>
                </div>
                <div className='comm-table__area mt-0'>
                    <Table
                        columns={columns}
                        dataSource={employeesData || undefined}
                        pagination={{
                            current: page,
                            pageSize: config.smallPageSize,
                        }}
                        rowKey={'no'}
                    />
                </div>
                <div className="comm-bx__between">
                    <div className="common-paging center">
                        <Pagination count={employeesData?.length || 0} page={page} setPage={setPage} perPage={config.smallPageSize}  />
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ApprovalLineModal;